import React, {useEffect, useState} from 'react';
import {Col, Row,Button,Divider,Tabs,TabsProps} from 'antd';
import DateRangeFilterItem from "../../../delivery/components/DateRangeFilterItem";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";
import ParcelFilterStyle from "../../../delivery/components/ParcelFilterStyle";
import InputFilterItem from "../../../delivery/components/InputFilterItem";


export interface PriceItemTab {
    label : string;
    key: string;
    children: React.ReactNode;
};

const PricingItemPanel: React.FC<{priceItemTabs:PriceItemTab[]}> = ({priceItemTabs}) => {
    const centered = false;
    return (
        <Tabs
            centered={centered}
            items={priceItemTabs}
            size="middle"
            style={{ width: '700px' }}
            destroyInactiveTabPane
        />
    );
}

export default PricingItemPanel;